import colors from 'material-colors';

import { DEFAULT_GEO_COLUMN_KEY } from 'uf/layers/geometryKey';
import {
  CuratedColumnSymbology,
  InterpolationTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<
  string,
  Record<string, CuratedColumnSymbology[]>
> = {};

symbologies['/public/dataset/tiger_zcta_2019_2020_04_15_16_33'] = {
  [DEFAULT_GEO_COLUMN_KEY]: [
    {
      display_hints: {
        distribution: null,
        interpolation: InterpolationTypes.CATEGORICAL,
        scale: SymbologyScales.CATEGORICAL,
        theme: 'custom',
      },
      paint: {
        'fill-color': 'transparent',
        'fill-opacity': 1,
      },
      type: SymbologyTypes.FILL,
    },
    {
      display_hints: {
        distribution: null,
        interpolation: InterpolationTypes.CATEGORICAL,
        scale: SymbologyScales.CATEGORICAL,
        theme: 'custom',
      },
      paint: {
        'line-color': colors.black,
        'line-opacity': 1,
        'line-width': 2,
      },
      type: SymbologyTypes.LINE,
    },
    {
      display_hints: {
        distribution: null,
        interpolation: InterpolationTypes.CATEGORICAL,
        scale: SymbologyScales.CATEGORICAL,
        theme: 'custom',
      },
      paint: {
        'circle-color': '#e377c2',
        'circle-opacity': 0.9,
        'circle-radius': 5,
        'circle-stroke-color': '#808080',
        'circle-stroke-width': 2,
      },
      type: SymbologyTypes.CIRCLE,
    },
  ],
};

export default symbologies;
